<template>
  <ElTable v-loading="isLoading" stripe class="raised" :data="apps">
    <ElTableColumn
      v-slot="{ row: app }"
      :label="$t('APPS.LIST.NAME')"
      min-width="200"
    >
      {{ getAppNameByLang(app) }}
    </ElTableColumn>

    <ElTableColumn
      v-slot="{ row: app }"
      min-width="200"
      :label="$t('APPS.PACKAGE_NAME')"
    >
      {{ app.packageName || '-' }}
    </ElTableColumn>

    <ElTableColumn
      v-slot="{ row: app }"
      width="150"
      :label="$t('APPS.DRAFT.CREATION_DATE')"
    >
      {{ translateDate(app.creationDate, lang) }}
    </ElTableColumn>

    <ElTableColumn
      v-slot="{ row: app }"
      width="180"
      :label="$t('APPS.LIST.STATUS')"
    >
      {{ getDraftAppStateText(app.currentState) }}
    </ElTableColumn>

    <ElTableColumn v-slot="{ row: app }" min-width="180">
      <div class="text-left">
        <ElButton size="mini" @click="goToApp(app)">{{ $t('EDIT') }}</ElButton>
        <DeleteWithConfirm :delete-function="() => deleteDraftApp(app)" />
      </div>
    </ElTableColumn>
  </ElTable>
</template>

<script>
import { DraftApps } from '@/api/api';
import appState from '@/mixins/appState';
import lang from '@/mixins/lang';
import { translateDate } from '@/utils/date';
import permissions from '@/mixins/permissions';
import DeleteWithConfirm from '@@/common/action-buttons/DeleteWithConfirm';
import getDraftAppStateText from './common/getDraftAppStateText';

export default {
  name: 'AppsTable',

  components: {
    DeleteWithConfirm,
  },

  mixins: [appState, permissions, lang],

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    apps: {
      type: Array,
      required: true,
    },
  },

  methods: {
    translateDate,
    getDraftAppStateText,

    getAppNameByLang({ nameFa, nameEn }) {
      const name = this.lang === 'fa' ? nameFa : nameEn;
      return name || '-';
    },

    goToApp({ id }) {
      this.$router
        .push({ name: 'draft-app', params: { appId: id } })
        .catch(() => {});
    },

    deleteDraftApp({ id }) {
      return DraftApps.delete(id)
        .then(({ message }) => {
          if (message) this.$message.success(message);
          this.$emit('delete-draft-app');
        })
        .catch(({ message }) => {
          this.$message.error(message);
        });
    },
  },
};
</script>
